module.exports = __webpack_public_path__ + "2c92b539102dd32ad14b60e310cd628d.fbx";